<template>
  <v-btn :href="href" target="_blank" rel="noopener" small outlined color="primary" class="text-none">
    <v-icon left small>{{ icon }}</v-icon>
    <slot>Apri nel marketing</slot>
    <v-icon right x-small>mdi-open-in-new</v-icon>
  </v-btn>
</template>

<script>
// Rimando all'altra piattaforma uCamp in una nuova scheda (UCAMP-87 plan 9).
export default {
  name: "ExternalPlatformLink",
  props: {
    href: { type: String, required: true },
    icon: { type: String, default: 'mdi-bullhorn-outline' },
  },
}
</script>
